export enum PartnerType {
  FOTOSCAPE = 'fotoscape',
  VERIZON = 'verizon',
  CRICKET = 'cricket',
  DT = 'dt',
  NEWSPOP = 'newspop'
}
